import React, { useState } from 'react';
import './Support.css';

import { PageTitle, FaqItem, Banner, ContactInfo, PortfolioTabs } from '../../../components';
import { supportContacts, supportFAQs } from '../../../constants';



const Support = () => {

  // Extract category names from supportFAQs
  const categories = Object.keys(supportFAQs);

  // Default category state
  const [category, setCategory] = useState(categories[0]);

  // State to manage the active accordion
  const [activeAccordionId, setActiveAccordionId] = useState(null);

  // Function to handle accordion click event
  const handleAccordionClick = (id) => {
    setActiveAccordionId((prevId) => (prevId === id ? null : id));
  };

  return (
    <>
      {/* Page title */}
      <PageTitle title={'Support Center'} page={'Support Center'} />

      <div className='support-center'>

        <section className='tab-info'>

          {/* Category Tabs */}
          <ul className="tab-buttons">
            {categories.map((item) => (
              <PortfolioTabs
                key={item}
                id={item}
                title={item.replace(/([A-Z])/g, ' $1').trim()} // Format category name
                setSelected={() => setCategory(item)}
                active={category === item}
                Icon={true} // PortfolioTabs supports an icon prop
              />
            ))}
          </ul>

          {/* FAQ Content based on selected category */}
          <div className='tab-sections'>

            <div className='faq tab-section active'>
              {/* Faq Accordion container */}
              <div className='accordion-container'>
                {/* Filter and render FAQs based on selected category */}
                {supportFAQs[category].map((faq) => (
                  <FaqItem
                    key={faq.question} // Unique key for React list rendering
                    id={faq.question} // FAQ ID
                    title={faq.question} // FAQ Question
                    content={faq.answer} // FAQ Answer
                    isActive={faq.question === activeAccordionId} // Check if the current FAQ is active
                    onAccordionClick={handleAccordionClick} // Click handler to toggle FAQ
                  />
                ))}
              </div>
            </div>

          </div>

        </section>

        {/* Banner Section with Call-to-Action */}
        <Banner 
          title="Your Trusted Partner for Car Service Support" 
          subTitle="Customer Support" 
          buttonText1="Get In Touch" 
          buttonLink1="Contact-us" 
        />

        {/* Contact Information Section */}
        <section>
          <ContactInfo contactContent={supportContacts} />
        </section>

      </div>
    </>
  );
};

export default Support;
